/* Constants */
import { env } from "../../constants"


/* The word after a number: 1 точка, 2 точки, 5 точек */
export const plural = (count, one, few, many) => {

    const value = Math.abs(parseInt(count)) || 0
    const tens = value % 100
    const units = value % 10

    if (tens > 10 && tens < 20) {
        return many
    }

    if (units === 1) {
        return one
    }

    if (units > 1 && units < 5) {
        return few
    }

    return many
}

/* The full address of a picture of a category, or nothing */
export const pictureOf = image => {

    if (!image) {
        return null
    }

    return `${env.mediapoint}categories/${image}`
}

/* The tile of the home screen of the app — a wide one takes two places in a row */
export const SIZES = [
    { key: "small", text: "Обычная", hint: "Одна клетка в ряду" },
    { key: "big", text: "Широкая", hint: "Две клетки — для главной категории группы" }
]

/* Each group gets a colour of its own, so the tabs and the cards of one group read together */
const TONES = [
    { accent: "#0279fc", soft: "rgba(2, 121, 252, 0.09)" },
    { accent: "#e91e63", soft: "rgba(233, 30, 99, 0.09)" },
    { accent: "#7c4dff", soft: "rgba(124, 77, 255, 0.1)" },
    { accent: "#00a884", soft: "rgba(0, 168, 132, 0.1)" },
    { accent: "#ff7a00", soft: "rgba(255, 122, 0, 0.1)" },
    { accent: "#00acc1", soft: "rgba(0, 172, 193, 0.1)" },
    { accent: "#f4511e", soft: "rgba(244, 81, 30, 0.1)" },
    { accent: "#5c6bc0", soft: "rgba(92, 107, 192, 0.1)" }
]

export const toneOf = id => {
    return TONES[(parseInt(id) || 0) % TONES.length]
}
